export class AuthStateModel {
  email: string;
  name: string;
  roles: string[];
  token!: string;
  attributes?: string[];
}

export class AuthTokenStateModel {
  username: string;
  password: string;
}

export class SetUserInfo {
  static readonly type = '[Auth] Set User Info';
  constructor(public payload: any) {}
}

export class AuthToken {
  static readonly type = '[AuthToken] API Auth token';
  constructor(public payload: AuthTokenStateModel) {}
}
export class CleanToken {
  static readonly type = '[AuthToken] Clean Auth token';
}
